import { Card, CardContent } from "@/components/ui/card"
import { tReports } from "@/features/staff/reports/format"

/**
 * A period with no closed shift has no report — and that is a sentence, not a
 * column of zeros.
 *
 * The distinction matters more here than on most screens. Every figure on this
 * page is defined as a sum over a set of Z reports; when the set is empty the
 * honest answer is "there is nothing to add up yet", and "$0.00" is a different
 * claim entirely — it says the restaurant took nothing. An owner who opens this
 * on a Saturday afternoon, before anyone has cut the till, must not read it as a
 * dead night.
 *
 * Two empties, two sentences:
 *
 *   never closed a shift    there is no report at any period, and the thing to
 *                           do about it is to start using the till.
 *   none in this period     the reports exist; this window just has no close in
 *                           it, so try another one.
 */
export function ReportEmptyState({ hasClosedShifts }: { hasClosedShifts: boolean }) {
  return (
    <Card density="compact" data-testid="report-empty">
      <CardContent className="space-y-1">
        <p className="text-sm font-medium">
          {tReports(hasClosedShifts ? "empty_period_title" : "empty_never_title")}
        </p>
        <p className="text-sm text-muted-foreground">
          {tReports(hasClosedShifts ? "empty_period_body" : "empty_never_body")}
        </p>
      </CardContent>
    </Card>
  )
}
